import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = [ 'pointsNeeded', 'couponValue', 'packageId' ]

  redeem(event) {
    event.preventDefault()
    this.dispatch('showRedeemModal', { target: document })
    this.couponValueTarget.innerText = event.params.couponValue
    this.pointsNeededTarget.innerText = event.params.pointsNeeded
    this.packageIdTarget.innerText = event.params.packageId
  }

  async confirmRedeem(event) {
    const packageId = this.packageIdTarget.innerText

    const res = await post(`/rewards_center/confirm_redeem/${packageId}`, {
      responseKind: 'turbo-stream'
    })
  }
}
